import { Component, ChangeDetectorRef, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators, FormArray } from '@angular/forms';
import { ApiService } from '../../../apiConnection/ApiService';
import { Urls } from '../../../apiConnection/urls';
import { CommonModule } from '@angular/common';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomSelectComponent } from '@/components/custom-select/custom-select.component';
import { CentToEurDirective } from "@/directives/centToEur.directive";
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { AuthenticationService } from '@/apiConnection/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';

@Component({
  selector: 'app-document-massive-invoices-form',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    CustomInputComponent,
    CustomSelectComponent,
    LoadingComponent,
  ],
  templateUrl: './document-massive-invoices-form.page.html'
})
export class DocumentMassiveInvoicesFormPage implements OnInit {
  public loading = false;
  public saveForm!: FormGroup;
  public dateStart: string | null = null;
  public dateEnd: string | null = null;
  public clientDocumentsList: any[] = [];
  public showResults = false;
  public deliveryNotes: any[] = [];
  public filteredDeliveryNotes: any[] = [];
  public invoiceResponse: any = null;
  public invoiceResponseError = '';
  public dropdowns: any = {
    clients: [],
    users: [],
    payMethods: [],
  };

  type: string | null = null;

  // hidden items dropdown when click outside
  @ViewChild('mainSearch') searchContainer!: ElementRef;
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.searchContainer && !this.searchContainer.nativeElement.contains(event.target)) {
      this.showResults = false;
    }
  }

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
    this.type = params['type'] || null;

    this.createForm();
    this.getDropdowns();
    })
  }

  createForm() {
    const currentUserId = this.authenticationService.currentUserValue.id

    this.saveForm = new FormGroup({
      user_id: new FormControl(currentUserId, [Validators.required]),
      date: new FormControl(new Date().toISOString().split('T')[0], [Validators.required]),
      client_id: new FormControl(null),
    });

  }


  getDropdowns() {
    const clientsConfig: any = {};
    if (this.type === 'default') {
      clientsConfig.special_clients = true;
    }else if(this.type !== 'default'){
      clientsConfig.special_clients = false;
    }

    const config: any = { users: {}, pay_methods: {}, clients: clientsConfig };

    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.dropdowns = {
          users: data.users || [],
          payMethods: data.pay_methods || [],
          clients: (data.clients || []).map((c: any) => ({ value: c.id, label: c.name })),
        };

        this.cdr.detectChanges();
      }
    });
  }

  changeClient() {
    const id = this.saveForm.get('client_id')?.value;
    const client = this.dropdowns.clients.find((c: any) => c.id == id);
    if (client) this.saveForm.get('phone')?.setValue(client.phone || '');

  }

  getType(): any{
    if(this.type){
      return this.type == 'dailly' ? 'diario' : 'varios'
    }
  }


  onDateStartChange(event : any) {
    this.dateStart = event;
  }

  onDateEndChange(event : any) {
    this.dateEnd = event;
  }

  dateFilter(){
      this.clientDocumentsList.map((product: any) => {
        const docDate = new Date(product.date);
        const startDate = this.dateStart ? new Date(this.dateStart) : null;
        const endDate = this.dateEnd ? new Date(this.dateEnd) : null;
        if (startDate && docDate < startDate) {
          return ;
        }
        if (endDate && docDate > endDate) {
          return ;
        }
    });

  }

  generateInvoices(print: boolean = false) {
    if (this.saveForm.valid) {
      this.loading = true;
      this.invoiceResponse = null;
      this.invoiceResponseError = '';

      const payload: any = {
        type : this.type,
        ...this.saveForm.value,
        print,
      };
      if (this.dateStart) payload.date_start = this.dateStart;
      if (this.dateEnd) payload.date_end = this.dateEnd;

      this.apiService.save(Urls.urls.documents + '/generate-massive-invoices', payload, 0).subscribe({
        next: (result: any) => {
          this.invoiceResponse = result;
          this.invoiceResponseError = '';
          this.loading = false;
          this.downloadInvoicePdfs(result?.pdfs);
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          this.loading = false;
          this.invoiceResponseError = Utils.extractErrorMessage(error) || 'Error al generar las facturas. Comprueba los datos e inténtalo de nuevo.';
          this.cdr.detectChanges();
        }
      });
    }
  }

  private downloadInvoicePdfs(pdfs: { document_id: number, filename: string, content: string }[]) {
    if (!pdfs || !pdfs.length) return;

    pdfs.forEach((pdf, index) => {
      // Pequeño retraso entre cada descarga para que el navegador no las bloquee/agrupe
      setTimeout(() => this.downloadBase64Pdf(pdf.content, pdf.filename), index * 300);
    });
  }

  private downloadBase64Pdf(base64: string, filename: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}